// src/components/result/ScoresRadar.js
import React from "react";

// 각 축에 쓸 key(점수 키)와 label(보여줄 텍스트) 정의
const TRAITS = [
  { key: "I", label: "I(내향)" },
  { key: "N", label: "N(직관)" },
  { key: "F", label: "F(감정)" },
  { key: "P", label: "P(인식)" },
  { key: "E", label: "E(외향)" },
  { key: "S", label: "S(감각)" },
  { key: "T", label: "T(사고)" },
  { key: "J", label: "J(판단)" },
];

function ScoresRadar({ scores }) {
  const size = 260;
  const center = size / 2;
  const maxRadius = 100;
  const levels = 4; // 25, 50, 75, 100 레벨 라인

  const norm = (value) => {
    const v = typeof value === "number" ? value : 0;
    return Math.max(0, Math.min(100, v)) / 100;
  };

  const points = TRAITS.map((trait, index) => {
    const angle = (index / TRAITS.length) * Math.PI * 2 - Math.PI / 2; // 위에서 시작
    const r = maxRadius * norm(scores[trait.key]); // 점수는 key로 읽기
    const x = center + r * Math.cos(angle);
    const y = center + r * Math.sin(angle);
    return `${x},${y}`;
  }).join(" ");

  return (
    <div className="result-radar-wrapper">
      <svg
        className="result-radar-svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        {/* 레벨 원형 가이드 */}
        {Array.from({ length: levels }, (_, i) => {
          const r = maxRadius * ((i + 1) / levels);
          return (
            <circle
              key={i}
              cx={center}
              cy={center}
              r={r}
              className="result-radar-level"
            />
          );
        })}

        {/* 축 라인 */}
        {TRAITS.map((trait, index) => {
          const angle = (index / TRAITS.length) * Math.PI * 2 - Math.PI / 2;
          const x = center + maxRadius * Math.cos(angle);
          const y = center + maxRadius * Math.sin(angle);
          return (
            <line
              key={trait.key}
              x1={center}
              y1={center}
              x2={x}
              y2={y}
              className="result-radar-axis"
            />
          );
        })}

        {/* 꼭짓점 점 */}
        {TRAITS.map((trait, index) => {
          const angle = (index / TRAITS.length) * Math.PI * 2 - Math.PI / 2;
          const r = maxRadius * norm(scores[trait.key]); // 점수 key
          const x = center + r * Math.cos(angle);
          const y = center + r * Math.sin(angle);
          return (
            <circle
              key={trait.key}
              cx={x}
              cy={y}
              r={3}
              className="result-radar-dot"
            />
          );
        })}

        {/* 축 라벨 */}
        {TRAITS.map((trait, index) => {
          const angle = (index / TRAITS.length) * Math.PI * 2 - Math.PI / 2;
          const r = maxRadius + 14;
          const x = center + r * Math.cos(angle);
          const y = center + r * Math.sin(angle);
          return (
            <text
              key={trait.key}
              x={x}
              y={y}
              className="result-radar-label"
              textAnchor="middle"
              dominantBaseline="middle"
            >
              {trait.label} {/* 여기서 E(외향) 이런 식으로 표시 */}
            </text>
          );
        })}

        {/* 폴리곤 영역 */}
        <polygon points={points} className="result-radar-polygon" />
      </svg>
    </div>
  );
}

export default ScoresRadar;
